import Vue from 'vue'
import Vuex from 'vuex'
import atom from '@tencent/vft-atom'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    payVip: null,
    userInfo: null
  },
  mutations: {
    savePayVip (state, payVip) {
      state.payVip = payVip
    },
    saveUserInfo (state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    getUserInfo ({ commit, state, dispatch }) {
      return atom.getMainUserInfo().then(userInfo => {
        var oldVal = state.userInfo
        var newVal = userInfo
        if (userInfo) {
          if (!oldVal) {
            commit('saveUserInfo', userInfo)
          } else if (oldVal.type !== newVal.type || oldVal.openId !== newVal.openId || oldVal.uin !== newVal.uin) {
            commit('saveUserInfo', userInfo)
          }
        }
        return userInfo
      })
    },
    getPayVip ({ commit }) {
      return atom.getPayVip(true, 1).then(payVip => {
        commit('savePayVip', payVip)
      })
    }
  },
  getters: {
    userType (state) {
      return state.userInfo && state.userInfo.type === 'wx' ? 'wx' : 'qq'
    }
  }
})
